import { render, staticRenderFns } from "./StorageLocationChangeAuslagern.vue?vue&type=template&id=fc4160f8&scoped=true"
import script from "./StorageLocationChangeAuslagern.vue?vue&type=script&setup=true&lang=js"
export * from "./StorageLocationChangeAuslagern.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4160f8",
  null
  
)

export default component.exports